<div class="canvasContainer">

    <div  class="ocrImg">
        
        <canvas #canvasEl [width]="width" [height]="height" (click)="draw()" class=""></canvas>
    </div>
    <div [hidden]="!loadingFlag" class="animation">
        
        <canvas #canvasAnimationEl [width]="width" [height]="height" class=""></canvas>
    </div>
</div>